// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3LAsA","productName":"Table_productName__2Spiy"};